<div style="margin-bottom: 32px" class="top-border">
    <div class="row   justify-content-start mb-2">
        <div class="col-9">
            <span class="iso-header">
                {{'bikeshop.shop_profile.whatsapp_integration.whatsapp_initiate_chat_template' | translate}}
            </span>
        </div>
        <div class="col-md-3">
            <div *ngIf="initiateChatTemplate.WhatsappActive && initiateChatTemplate.WATemplateName && initiateChatTemplate.ID">
                <button pButton class="p-button-raised full-width p-mini green" (click)="openPanel()"
                    label="{{'general.update_template' | translate}}"></button>
            </div>
            <div *ngIf="!(initiateChatTemplate.WhatsappActive && initiateChatTemplate.WATemplateName) && initiateChatTemplate.ID">
                <button pButton class="p-button-raised full-width p-mini" (click)="openPanel()"
                    label="{{'general.create_template' | translate}}"></button>
            </div>
        </div>
    </div>
    <div class="row justify-content-start mb-2">
        <div class="col-12">
            <span class="">
                {{'bikeshop.shop_profile.whatsapp_integration.whatsapp_initiate_chat_template_description' | translate}}
            </span>
        </div>
    </div>
</div>


<p-sidebar #navSideBar [(visible)]="showMessageType" position="right"
    [style]="{width:'90em', background: '#F6F6F8', 'overflow-x': 'auto', 'max-width': '100%'}"
    (onHide)="navSideBar.destroyModal(); getWhatsAppInitiateChatTemplate();">
    <div *ngIf="showMessageType">
        <app-message-type-panel [selectedMessageTemplate]="initiateChatTemplate" [whatsappConfiguredEnabled]="true"
            [messageTemplates]="initiateChatTemplate" (closePanel)="closePanel()"></app-message-type-panel>
    </div>
</p-sidebar>